import styles from './style.module.scss';
import { getIconUrl } from '../../lib/cdn-icon-url';
import { ImgComponent } from '../components/img-component';
import { useState } from 'react';
import getFormatMessage from '../../locales/get-format-message';
import classNames from 'classnames';

interface IProps {
  readonly keyBenefitsConfig: {
    readonly title: string;
    readonly desc: string;
    readonly iconUrl: string;
  }[];
}

export const ProductsKeyBenefits = (props: IProps) => {
  const [activeItem, setActiveItem] = useState<number[]>([0, 1, 2, 3]); // 默认全部展开，保留功能
  const clickActive = (val: number) => {
    const newActive = Object.assign([], activeItem);
    if (newActive.includes(val)) {
      newActive.splice(newActive.indexOf(val), 1);
    } else {
      newActive.push(val);
    }
    setActiveItem(newActive);
  }
  return (
    <div className={styles.productsKeyBenefitsContentBox}>
      <div className={styles.productsKeyBenefitsContentTopBox}>
        {props.keyBenefitsConfig && props.keyBenefitsConfig?.length !== 0 && (
          <div className={classNames(styles.productsKeyBenefitsItemBox0, activeItem.includes(0) ? styles.productsKeyBenefitsItemBoxActive : '')}>
            <div className={styles.keyBenefitsItemImgBox}>
              <ImgComponent
                key={props.keyBenefitsConfig[0]?.iconUrl || ''}
                url={getIconUrl(props.keyBenefitsConfig[0]?.iconUrl || '')}
                className={styles.keyBenefitsItemBg}
              />
            </div>
            <div className={styles.keyBenefitsItemTitle}>
              <span>{props.keyBenefitsConfig[0]?.title || ''}</span>
            </div>
            <div className={styles.keyBenefitsItemDesc}>
              {props.keyBenefitsConfig[0]?.desc || ''}
            </div>
            <div className={styles.moreBtn}>
              <span onClick={() => clickActive(0)}>
                <span>
                  {activeItem.includes(0) ? getFormatMessage('put_away') : getFormatMessage('more')}
                </span>
                <div className={classNames(styles.downIcon, activeItem.includes(0) ? styles.downIconRotate : '')} />
              </span>
            </div>
          </div>
        )}
        {props.keyBenefitsConfig && props.keyBenefitsConfig?.length > 1 && (
          <div className={styles.productsKeyBenefitsRightItemBox}>
            <div className={classNames(styles.productsKeyBenefitsItemBox1, activeItem.includes(1) ? styles.productsKeyBenefitsItemBoxActive : '')}>
              <div className={styles.keyBenefitsItemImgBox}>
                <ImgComponent
                  key={props.keyBenefitsConfig[1]?.iconUrl || ''}
                  url={getIconUrl(props.keyBenefitsConfig[1]?.iconUrl || '')}
                  className={styles.keyBenefitsItemBg}
                />
              </div>
              <div className={styles.keyBenefitsItemTitle}>
                {props.keyBenefitsConfig[1]?.title || ''}
              </div>
              <div className={styles.keyBenefitsItemDesc}>
                {props.keyBenefitsConfig[1]?.desc || ''}
              </div>
              <div className={styles.moreBtn}>
                <span onClick={() => clickActive(1)}>
                  <span>
                    {activeItem.includes(1) ? getFormatMessage('put_away') : getFormatMessage('more')}
                  </span>
                  <div className={classNames(styles.downIcon, activeItem.includes(1) ? styles.downIconRotate : '')} />
                </span>
              </div>
            </div>
            {props.keyBenefitsConfig?.length > 2 && (
              <div className={classNames(styles.productsKeyBenefitsItemBox2, activeItem.includes(2) ? styles.productsKeyBenefitsItemBoxActive : '')}>
                <div className={styles.keyBenefitsItemImgBox}>
                  <ImgComponent
                    key={props.keyBenefitsConfig[2]?.iconUrl || ''}
                    url={getIconUrl(props.keyBenefitsConfig[2]?.iconUrl || '')}
                    className={styles.keyBenefitsItemBg}
                  />
                </div>
                <div className={styles.keyBenefitsItemTitle}>
                  {props.keyBenefitsConfig[2]?.title || ''}
                </div>
                <div className={styles.keyBenefitsItemDesc}>
                  {props.keyBenefitsConfig[2]?.desc || ''}
                </div>
                <div className={styles.moreBtn}>
                <span onClick={() => clickActive(2)}>
                  <span>
                    {activeItem.includes(2) ? getFormatMessage('put_away') : getFormatMessage('more')}
                  </span>
                  <div className={classNames(styles.downIcon, activeItem.includes(2) ? styles.downIconRotate : '')} />
                </span>
              </div>
              </div>
            )}
          </div>
        )}
      </div>
      {props.keyBenefitsConfig &&
        props.keyBenefitsConfig?.length !== 0 &&
        props.keyBenefitsConfig.map((item, index) => {
          if (index < 3) {
            return null;
          }
          return (
            <div className={classNames(styles.productsKeyBenefitsItemBox3, activeItem.includes(3) ? styles.productsKeyBenefitsItemBoxActive : '')}>
              <div className={styles.keyBenefitsItemImgBox}>
                <ImgComponent
                  key={item?.iconUrl || ''}
                  url={getIconUrl(item?.iconUrl || '')}
                  className={styles.keyBenefitsItemBg}
                />
              </div>
              <div className={styles.keyBenefitsItemTitle}>
                {item?.title || ''}
              </div>
              <div className={styles.keyBenefitsItemDesc}>
                {item?.desc || ''}
              </div>
              <div className={styles.moreBtn}>
                <span onClick={() => clickActive(3)}>
                  <span>
                    {activeItem.includes(3) ? getFormatMessage('put_away') : getFormatMessage('more')}
                  </span>
                  <div className={classNames(styles.downIcon, activeItem.includes(3) ? styles.downIconRotate : '')} />
                </span>
              </div>
            </div>
          );
        })}
    </div>
  );
};
